import React from "react";
import { ACCENT, SectionTitle, monoFont } from "./SectionHeading";

const RECOMMENDATIONS = [
  {
    title: "Subject line too long",
    description:
      'Emails with shorter subject lines (under 40 chars) see 18% higher open rates. Consider shortening "Your Weekly Roundup of Top Picks and Deals" to something punchier.',
    metric: "+18% opens",
  },
  {
    title: "Shift send time to 9:15 AM",
    description:
      "Segment 'Active Shoppers' engages most between 9–10 AM on weekdays. Moving from your current 2 PM slot could boost click-through.",
    metric: "+24% CTR",
  },
  {
    title: "Add a follow-up for non-openers",
    description:
      "32% of this segment didn't open the last campaign. A resend with a new subject line 48 hours later typically recovers 11% of those opens.",
    metric: "+11% recovery",
  },
];

const STATS = [
  ["3.2×", "Higher open rates after AI optimization"],
  ["47%", "Avg. improvement in click-through rates"],
  ["24h", "Time to first AI recommendation"],
];

const CampaignOptimizationSection = () => {
  return (
    <section
      className="border-y border-neutral-200/70 bg-white px-6 py-28 lg:px-10 lg:py-36"
      style={{ fontFamily: "var(--font-geist)" }}
    >
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-14 lg:grid-cols-12 lg:gap-16">
        {/* Left: copy + stats */}
        <div className="lg:col-span-5">
          <SectionTitle
            size="md"
            eyebrow="Campaign intelligence"
            title="Campaigns that"
            em="optimize themselves"
            body="Fluvo watches every send and tightens the playbook in real time. Subject lines, send time, segmentation — all tuned for the outcome you set."
          />
          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-neutral-200 pt-8">
            {STATS.map(([value, label]) => (
              <div key={value}>
                <div className="text-[36px] font-medium leading-none tracking-[-0.03em] text-neutral-900">
                  {value}
                </div>
                <p className="mt-2 text-[13px] leading-[1.45] text-neutral-500">
                  {label}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Right: recommendations panel */}
        <div className="overflow-hidden rounded-2xl border border-neutral-200 bg-[#fafafa] lg:col-span-7">
          <div className="flex h-14 items-center justify-between border-b border-neutral-200 bg-white px-6">
            <span className="flex items-center gap-2.5 text-[14px] font-medium text-neutral-900">
              <span
                className="h-2 w-2 animate-pulse rounded-full"
                style={{ background: ACCENT }}
              />
              AI recommendations
            </span>
            <span className="text-[11px] text-neutral-400" style={monoFont}>
              Updated 2 min ago
            </span>
          </div>

          <div className="divide-y divide-neutral-200">
            {RECOMMENDATIONS.map((rec) => (
              <div
                key={rec.title}
                className="flex gap-5 px-6 py-6 transition-colors hover:bg-white"
              >
                <span
                  className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full"
                  style={{ background: ACCENT }}
                />
                <div className="min-w-0 flex-1">
                  <div className="mb-1.5 flex items-start justify-between gap-3">
                    <h4 className="text-[15px] font-medium text-neutral-900">
                      {rec.title}
                    </h4>
                    <span
                      className="inline-flex h-6 shrink-0 items-center rounded-full px-2 text-[11px] font-medium"
                      style={{
                        background: `${ACCENT}1f`,
                        color: ACCENT,
                        ...monoFont,
                      }}
                    >
                      {rec.metric}
                    </span>
                  </div>
                  <p className="text-[14px] leading-[1.55] text-neutral-500">
                    {rec.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex h-12 items-center justify-between border-t border-neutral-200 bg-white px-6">
            <p className="text-[11px] text-neutral-400" style={monoFont}>
              3 recommendations · last 7 days
            </p>
            <span className="text-[12px] font-medium text-neutral-700">
              View all →
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CampaignOptimizationSection;
